import React, { useState, useEffect, useContext } from "react"
import { io } from "socket.io-client";

// Own
import InstrumentList from "./InstrumentList"
import PassiveInstrumentList from "./PassiveInstrumentList"
import InstrumentTable from "./InstrumentTable"
import AddButton from "./AddButton"
import { backendApi, clientConfigApplication } from "../../api/calls"
import { AuthContext } from "../../../context/auth-context"
import { QuerybarContext } from '../../../context/querybarContext';
import SnackBar from "../../layout/SnackBar"
import TerminalViewer from "./terminalViewer"

// MUI V5
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';

// ICONS
import CircleIcon from '@mui/icons-material/Circle';
import TerminalIcon from '@mui/icons-material/Terminal';

export const instrumentListContext = React.createContext();



async function getInstruments() {
    return await backendApi.get("/api/organization/instruments", clientConfigApplication)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err
        })
}


export default function Instruments() {
    const [instruments, setInstruments] = useState([""]);
    const [mySnackBar, setMySnackBar] = useState({ display: false, type: "", message: "" });
    const [socketIsConnected, setSocketIsConnected] = useState(false);
    const [socketioSession, setSocketioSession] = useState("");
    const [liveInstrumentData, setLiveInstrumentData] = useState();
    const [instrumentTerminal, setInstrumentTerminal] = useState([]);
    const [terminalToggle, setTerminalToggle] = useState(false)
    const [socket, setSocket] = useState(null)
    const [authToken, setAuthToken] = useState(null)

    const instrumentsContext = useContext(instrumentListContext);
    const usercontext = useContext(AuthContext);
    const QueryContext = useContext(QuerybarContext);
    const userCanManageInstruments = usercontext.state.user.permissions.addInstruments;
    const theme = useTheme();
    const largeScreen = useMediaQuery(theme.breakpoints.up('md'));

    const asyncSessionStorage = {
        setItem: function (key, value) {
            return Promise.resolve().then(function () {
                sessionStorage.setItem(key, value);
            });
        },
        getItem: function (key) {
            return Promise.resolve().then(function () {
                return sessionStorage.getItem(key);
            });
        }
    };

    async function getToken(){
        let token = await asyncSessionStorage.getItem("seisodinCloudJwtToken")
        return token
    }

    useEffect(() => {
        // https://stackoverflow.com/questions/72732804/how-to-use-socket-io-with-localstorage-item-as-query-value
        newSocket()
    }, [])

    function newSocket(){
        requestPing().then(d => {
            getToken().then(t => {
                console.log("Now creating new socket")
                setSocket(io(
                    "",
                    {
                        reconnection: false,
                        autoConnect: false,
                        auth: { token: t },
                        // auth: { token: sessionStorage.getItem("seisodinCloudJwtToken") },
                    },
                  ))
            }).catch(e => {
                console.log("unable to retrieve token, so no new socket was made")
            })
        }).catch(e => {
            console.log("error pinging or creating socket")
        })
    }
    

    useEffect(() => {
        const onConnect = () => {
            console.log("SOCKET connected")
            setSocketIsConnected(true);

            // Write to instrumentTerminal
            setInstrumentTerminal((currentMessages) => {
                let newArr = [...currentMessages];
                let event = new Date(Date.now())
                if(newArr.length >= 100){
                    newArr.shift()
                    newArr.push(event.toISOString() + " Connection Established")
                } else {
                    newArr.push(event.toISOString() + " Connection Established")
                }
                return ([...newArr])
                // return ([...currentMessages, value])
            });
        }
        
        const onDisconnect = () => {
            console.log("SOCKET disconnected")
            setSocketIsConnected(false);

            // Write to instrumentTerminal
            setInstrumentTerminal((currentMessages) => {
                let newArr = [...currentMessages];
                let event = new Date(Date.now())
                if(newArr.length >= 100){
                    newArr.shift()
                    newArr.push(event.toISOString() + " Connection Closed")
                } else {
                    newArr.push(event.toISOString() + " Connection Closed")
                }
                return ([...newArr])
                // return ([...currentMessages, value])
            });

            // Set retry
            setTimeout(() => {
                socket.connect("",{
                    reconnection: false,
                    autoConnect: false,
                    auth: { token: sessionStorage.getItem("seisodinCloudJwtToken") }
                });
              }, 5000);// attempt reconnecting in 5 seconds
        }
    
        const onWelcomeEvent = (value) => {
            // console.log("SOCKET welcome")
            setSocketioSession(value);
        }
        
        const onInstrumentChanges = (value) => {
            // console.log("SOCKET instrument change")
            setLiveInstrumentData(value)
            setInstruments([...value])
        }

        const onInstrumentTerminal = (value) => {
            // console.log("SOCKET instrument terminal change")
            setInstrumentTerminal((currentMessages) => {
                let newArr = [...currentMessages];
                if(newArr.length >= 100){
                    newArr.shift()
                    newArr.push(value)
                } else {
                    newArr.push(value)
                }
                return ([...newArr])
                // return ([...currentMessages, value])
            });

        }

        const onConnectError = (err) => {
            setSocketIsConnected(false);

                console.log(`socket connect_error due to ${err.message}`);
                if(err.message === "xhr poll error"){
                    console.log("polling error indicates the server may not be accessible")
                    console.log("Attempting to start connection in 5sec")
                    setTimeout(() => {
                        socket.connect("",{
                            reconnection: false,
                            autoConnect: false,
                            auth: { token: sessionStorage.getItem("seisodinCloudJwtToken") }
                        });
                      }, 5000);// attempt reconnecting in 5 seconds
                } else if (err.message === "timeout"){
                    console.log("timeout error indicates the server may not be accessible")
                    console.log("Attempting to start connection in 5sec")
                    setTimeout(() => {
                        socket.connect("",{
                            reconnection: false,
                            autoConnect: false,
                            auth: { token: sessionStorage.getItem("seisodinCloudJwtToken") }
                        });
                      }, 5000);// attempt reconnecting in 5 seconds
                } else if(err.message === "jwt expired"){
                    console.log("connection refused because jwt expired")    
                    // requestPing()
                    cleanupSocket()
                    newSocket()
                    setTimeout(() => {
                        socket.connect("",{
                            reconnection: false,
                            autoConnect: false,
                            auth: { token: sessionStorage.getItem("seisodinCloudJwtToken") }
                            // auth: { token: sessionStorage.getItem("seisodinCloudJwtToken") }
                        });
                      }, 5000);// attempt reconnecting in 5 seconds
                } else {
                    console.log("error type will not be handled")
                }
        }

        const onReconnectionAttempt = () => {
            setSocketIsConnected(false)
            console.log("socket attempting reconnecting")
        }

        const onReconnectSuccess = () => {
            setSocketIsConnected(true)
            console.log("socket reconnected with id",socket.id)
        }


        if(socket !== null){
            socket.connect("",{
                // reconnectionDelayMax: 10000,
                // forceNew: true,
                autoConnect: false,
                auth: { token: authToken }
            });    

            socket.on('connect', onConnect);
            socket.on('disconnect', onDisconnect);
            socket.on('welcome', onWelcomeEvent);
            socket.on('instrumentChanges', onInstrumentChanges);
            socket.on('instrumentTerminal', onInstrumentTerminal);
            socket.on('connect_error', onConnectError);
            socket.on("reconnection_attempt", onReconnectionAttempt);
            socket.on("reconnect", onReconnectSuccess);
        } 

        return () => {
            if(socket !== null){
                socket.off('connect', onConnect);
                socket.off('disconnect', onDisconnect);
                socket.off('welcome', onWelcomeEvent);
                socket.off('instrumentChanges', onInstrumentChanges);
                socket.off('connect_error', onConnectError);
                socket.off("reconnection_attempt", onReconnectionAttempt);
                socket.off("reconnect", onReconnectSuccess);
                // socket.disconnect(); // kill the websocket between frontend and backend
                cleanupSocket()
            }
        };
      }, [socket]);

    function cleanupSocket(){
        if(socket !== null){
            console.log("cleanupSocket")
            socket.removeAllListeners(); // instead of individual socket.off. Necessary to stop listeners after leaving page
            socket.disconnect(); // kill the websocket between frontend and backend
            setSocket(null)
        }
    }

    async function requestPing(){
        return await backendApi.get("/api/test/ping").then((res) => {
            console.log("ping backend")
            return res;
        })
    }
  

    function getAllInstruments() {
        QueryContext.setQuerybarActive(true)
        const user = getInstruments().then(instruments => {
            setInstruments(instruments.data.instruments)
            return instruments.data.instruments
        }).then(instruments => {
            QueryContext.setQuerybarActive(false)
            return instruments
        }).catch(e => {
            QueryContext.setQuerybarActive(false)
            // let errorMessage = e.response.data.message || e.message;
            let errorMessage = "unknown error";
            setMySnackBar({ display: true, type: "error", message: `${errorMessage ? `${errorMessage}.` : ""} ` });
            setTimeout(function () {
                setMySnackBar({ display: false, type: "", message: "" });
            }, 5000);
        })

        return user
    }


    useEffect(() => {
        getAllInstruments();
        getInstrumentsTerminalHistory().then(d => {
            setInstrumentTerminal(d?.data?.history.reverse())
        }).catch(e => {
            console.log("error getting instrument terminal history")
            console.log(e)
        })
    }, []);

    useEffect(() => {
        // console.log("instrumentsContext.instruments changed")
    }, [instruments])

    function handleTerminalToggle(){
        setTerminalToggle(!terminalToggle)
    }

    async function getInstrumentsTerminalHistory() {
        return await backendApi.get("/api/organization/instrumentsTerminalHistory", clientConfigApplication)
            .then(d => {
                return d;
            })
            .catch(e => {
                throw new Error(e.message)
            })
    }

    return (
        <div>
            <instrumentListContext.Provider value={{ instruments: instruments, setInstruments: setInstruments }}>
                {
                    mySnackBar.display === true && mySnackBar.type === "error" ?
                        <SnackBar type={mySnackBar.type} message={mySnackBar.message} />
                        : ""
                }
                <MuiAppBar
                    style={{
                        position: "-webkit-sticky",
                        position: "sticky", // eslint-disable-line
                        top: largeScreen ? theme.spacing(8) : theme.spacing(7),
                        marginTop: "-78px"
                    }} 
                    elevation={0} 
                    sx={{background: "transparent"}}
                >
                    <Toolbar variant="dense">
                        <Box style={{flexGrow: 1}}>
                        </Box>
                        <Stack direction="row" spacing={1}>
                            <Tooltip title="Show/Hide terminal window">
                                <Button variant="contained" onClick={handleTerminalToggle}><TerminalIcon/></Button>
                            </Tooltip>
                            {userCanManageInstruments ? <AddButton /> : <></>}
                        </Stack>
                    </Toolbar>
                </MuiAppBar>
                <Collapse in={terminalToggle}>
                    <TerminalViewer messages={instrumentTerminal} socketIsConnected={socketIsConnected}/>
                </Collapse>
                <div >
                    <InstrumentTable activeInstruments={true} key="activeinstruments" socketIsConnected={socketIsConnected} socketioSession={socketioSession}/>
                </div>
                <div >
                    <InstrumentTable activeInstruments={false} key="passive instruments" socketIsConnected={socketIsConnected} socketioSession={socketioSession}/>
                </div>               
            </instrumentListContext.Provider>
        </div>
    )
}

